// extracted by mini-css-extract-plugin
module.exports = {"cont":"InputCreateGoods_cont__3PM2D","box":"InputCreateGoods_box__2wKkB","sm":"InputCreateGoods_sm__1llIb"};